import CryptoJS from "crypto-js";
const secretKey = "CXARSI123"

export const encrypt = (text: any) => {
    const b64 = CryptoJS.AES.encrypt(text, secretKey).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const eHex = e64.toString(CryptoJS.enc.Hex);
    return eHex;
};
export const decrypt = (cipherText: string | undefined) => {
    const reb64 = CryptoJS.enc.Hex.parse(cipherText ?? "");
    const bytes = reb64.toString(CryptoJS.enc.Base64);
    const dec = CryptoJS.AES.decrypt(bytes, secretKey);
    const plain = dec.toString(CryptoJS.enc.Utf8);
    return plain;
};
